import { CurrencyPipe, DatePipe, DecimalPipe, registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideRouter } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { provideAppCore } from './core/core.providers';
import { I18nService } from './core/i18n.service';
import { AppRoute } from './shared/app.route.enum';
import { APP_ROUTE, APP_TITLE, BreadcrumbsService } from './shared/components/breadcrumbs/breadcrumbs.service';
import { DayjsDateAdapter } from './shared/date-adapters/dayjs-date-adapter';
import { MinuteSecondsPipe } from './shared/pipes/minute-seconds.pipe';
import { appRoutes } from './app.routes';

registerLocaleData(localeDe);
registerLocaleData(localeEn);

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(appRoutes),
    provideAppCore(),
    importProvidersFrom(TranslateModule.forRoot()),
    BreadcrumbsService,
    CurrencyPipe,
    DatePipe,
    DecimalPipe,
    MinuteSecondsPipe,
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: APP_ROUTE, useValue: AppRoute },
    { provide: APP_TITLE, useValue: 'Hypecast' },
    { provide: LOCALE_ID, useFactory: (i18nService: I18nService) => i18nService.language, deps: [I18nService] },
    { provide: DateAdapter, useClass: DayjsDateAdapter, deps: [MAT_DATE_LOCALE] },
  ],
};
